export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/ee9346a7a9322dc42520ebdf49402b79.svg";